import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: (state) => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get('CMS/api/TagsQuery').then(r => {
        commit('setList', r.data.data)
      })
    },
    create({ commit, dispatch }, model) {
      return ajax.post('CMS/api/Tags', model).then(r => {
        dispatch('fetch')
      })
    },
    remove({ commit, dispatch }, id) {
      return ajax.delete('CMS/api/Tags', { data: { "id": id } }, { headers: { 'Content-Type': 'application/json' } }).then(r => {
        dispatch('fetch')
      })
    },
    update({ commit, dispatch }, model) {
      return ajax.put('CMS/api/Tags', model).then(r => {
        dispatch('fetch')
      })
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
}
